import classNames from 'classnames/bind';
import commaNumber from 'comma-number';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import styles from './Monitor.module.scss';

import { Cell, Row } from '@/components/ui/dashboard/Monitor';
import { getDistance } from '@/utils/MapUtils';

const cx = classNames.bind(styles);

const Monitor = ({ robotId }) => {
  const droneOsd = useSelector((state) => state.telemetry[robotId]?.droneOsd);
  const controlPayloads = useSelector((state) => state.telemetry[robotId]?.controlPayloads);
  const dockOsdStatus = useSelector((state) => state.telemetry[robotId]?.dockOsdStatus);

  // GPS Fix Type based on position_state.quality
  const gpsFixType = useMemo(() => {
    switch (droneOsd?.position_state?.quality) {
      case 0:
        return 'No GPS';
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        return `Gear ${droneOsd.position_state.quality}`;
      case 10:
        return 'RTK Fixed';
      default:
        return '-';
    }
  }, [droneOsd]);

  // Distance to Home
  const distanceToHome = useMemo(() => {
    if (!droneOsd) return 0;
    if (!controlPayloads && !dockOsdStatus) return 0;

    const globalPosition = {
      lat: droneOsd.latitude,
      lng: droneOsd.longitude,
    };
    let homePosition = null;
    if (controlPayloads) {
      homePosition = {
        lat: controlPayloads.home_latitude,
        lng: controlPayloads.home_longitude,
      };
    } else {
      homePosition = {
        lat: dockOsdStatus.latitude,
        lng: dockOsdStatus.longitude,
      };
    }

    return getDistance(globalPosition, homePosition);
  }, [droneOsd, controlPayloads, dockOsdStatus]);

  // Relative Altitude, Horizontal Speed, Vertical Speed
  const { ralt, horizontalSpeed, verticalSpeed } = useMemo(() => {
    return {
      ralt: droneOsd?.elevation ?? 0,
      horizontalSpeed: droneOsd?.horizontal_speed ?? 0,
      verticalSpeed: droneOsd?.vertical_speed ?? 0,
    };
  }, [droneOsd]);

  return (
    <div className={cx('container')}>
      <div className={cx('rows')}>
        <Row label="GPS Fix Type" value={gpsFixType} />
        <Row label="Distance to Home" value={commaNumber(distanceToHome.toFixed(2))} unit="m" />
      </div>
      <div className={cx('boxes')}>
        <Cell data={[{ title: 'Relative Alt.', value: commaNumber(ralt.toFixed(2)), unit: 'm' }]} />
        <Cell data={[{ title: 'Horizontal Spd.', value: commaNumber(horizontalSpeed.toFixed(2)), unit: 'm/s' }]} />
        <Cell data={[{ title: 'Vertical Speed', value: commaNumber(verticalSpeed.toFixed(2)), unit: 'm/s' }]} />
      </div>
    </div>
  );
};

export default Monitor;
